/* Utilitaires couleur pour le branding sponsor.

   Les sponsors saisissent leurs couleurs librement depuis l'admin : on ne peut
   donc pas poser du texte blanc par défaut sur un fond qui peut être un jaune
   pâle. Ces helpers dérivent une couleur de texte lisible et des teintes, en
   tolérant les valeurs non exploitables (variable CSS de repli, champ vide). */

/** {r,g,b} depuis un hex #rgb ou #rrggbb, ou null si la valeur n'en est pas un. */
export function hexToRgb(hex) {
  if (typeof hex !== "string") return null;
  const raw = hex.trim().replace(/^#/, "");
  if (!/^([0-9a-f]{3}|[0-9a-f]{6})$/i.test(raw)) return null;
  const full = raw.length === 3 ? raw.split("").map((c) => c + c).join("") : raw;
  return {
    r: parseInt(full.slice(0, 2), 16),
    g: parseInt(full.slice(2, 4), 16),
    b: parseInt(full.slice(4, 6), 16),
  };
}

/** Texte lisible sur ce fond : sombre sur couleur claire, blanc sinon. */
export function readableOn(hex) {
  const rgb = hexToRgb(hex);
  if (!rgb) return "#fff";
  // Luminance relative (coefficients WCAG), seuil calé pour rester lisible
  // sur les jaunes et cyans vifs — fréquents chez les opérateurs télécom.
  const lum = (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
  return lum > 0.6 ? "#1a1a1a" : "#fff";
}

/** Même couleur en translucide, ou "transparent" si l'entrée est inexploitable. */
export function tint(hex, alpha) {
  const rgb = hexToRgb(hex);
  return rgb ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})` : "transparent";
}

/** Dégradé de marque d'un sponsor, ou null s'il n'a aucune couleur exploitable
    (l'appelant retombe alors sur la couleur plateforme).
    La couleur secondaire est validée séparément : une valeur invalide rendrait
    toute la déclaration CSS caduque et le fond disparaîtrait complètement. */
export function sponsorGradient(primary, secondary) {
  if (!hexToRgb(primary)) return null;
  const end = hexToRgb(secondary) ? secondary : primary;
  return `linear-gradient(155deg, ${primary} 0%, ${end} 100%)`;
}
